import "../../index60.css";
import { jsxs as r, jsx as t, Fragment as L } from "react/jsx-runtime";
import { ChevronRightLineIcon as h, CloseLineIcon as g } from "@ifrc-go/icons";
import { _ as s } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import w from "../InlineLayout/index.js";
import C from "../../hooks/useSpacingToken.js";
const T = "_tab-wrapper_9q0s6_1", P = "_active-border_9q0s6_7", W = "_active_9q0s6_7", x = "_bottom-border_9q0s6_18", B = "_tab-layout_9q0s6_24", I = "_errored_9q0s6_40", k = "_color-variant-text_9q0s6_44", F = "_color-variant-primary_9q0s6_48", j = "_color-variant-secondary_9q0s6_52", O = "_style-variant-tab_9q0s6_56", A = "_style-variant-nav_9q0s6_77", R = "_style-variant-pill_9q0s6_87", z = "_style-variant-vertical_9q0s6_98", D = "_style-variant-vertical-compact_9q0s6_115", E = "_forward-icon_9q0s6_123", G = "_style-variant-step_9q0s6_137", H = "_completed_9q0s6_146", J = "_visual-feedback_9q0s6_151", K = "_disabled_9q0s6_174", M = "_step-wrapper_9q0s6_221", Q = "_dot_9q0s6_226", U = "_icon_9q0s6_236", X = "_dot-wrapper_9q0s6_247", Y = "_before-line_9q0s6_252", Z = "_after-line_9q0s6_261", $ = "_first-step_9q0s6_294", aa = "_last-step_9q0s6_307", a = {
  tabWrapper: T,
  activeBorder: P,
  active: W,
  bottomBorder: x,
  tabLayout: B,
  errored: I,
  colorVariantText: k,
  colorVariantPrimary: F,
  colorVariantSecondary: j,
  styleVariantTab: O,
  styleVariantNav: A,
  styleVariantPill: R,
  styleVariantVertical: z,
  styleVariantVerticalCompact: D,
  forwardIcon: E,
  styleVariantStep: G,
  completed: H,
  visualFeedback: J,
  disabled: K,
  stepWrapper: M,
  dot: Q,
  icon: U,
  dotWrapper: X,
  beforeLine: Y,
  afterLine: Z,
  firstStep: $,
  lastStep: aa
}, ta = {
  text: a.colorVariantText,
  primary: a.colorVariantPrimary,
  secondary: a.colorVariantSecondary
}, ea = {
  tab: a.styleVariantTab,
  pill: a.styleVariantPill,
  step: a.styleVariantStep,
  nav: a.styleVariantNav,
  vertical: a.styleVariantVertical,
  "vertical-compact": a.styleVariantVerticalCompact
}, ra = {
  tab: 1,
  pill: 0,
  step: -1,
  nav: 0,
  vertical: 0,
  "vertical-compact": -2
};
function _a(p) {
  const {
    colorVariant: _ = "primary",
    styleVariant: e = "nav",
    spacingOffset: d = ra[e],
    className: m,
    disabled: v,
    children: y,
    withoutPadding: b = !1,
    active: o,
    spacing: V,
    tabWrapperClassName: f,
    stepCompleted: n,
    isFirstStep: q,
    isLastStep: N,
    errored: c,
    after: u,
    ...S
  } = p, l = C({
    modes: ["padding-inline"],
    spacing: V,
    offset: -5
  }), i = /* @__PURE__ */ r(
    w,
    {
      ...S,
      withPadding: !(b || e === "vertical-compact" || e === "nav"),
      className: s(
        a.tabLayout,
        ta[_],
        ea[e],
        n && a.completed,
        v && a.disabled,
        o && a.active,
        c && a.errored,
        m
      ),
      spacingOffset: d,
      withAdditionalInlinePadding: e === "pill",
      after: /* @__PURE__ */ r(L, { children: [
        u,
        e === "vertical-compact" && /* @__PURE__ */ t(h, { className: a.forwardIcon })
      ] }),
      children: [
        y,
        /* @__PURE__ */ t("span", { className: a.visualFeedback })
      ]
    }
  );
  return e === "tab" ? /* @__PURE__ */ r(
    "div",
    {
      className: s(
        a.tabWrapper,
        f,
        o && a.active
      ),
      children: [
        /* @__PURE__ */ t("div", { className: s(a.bottomBorder, l) }),
        i,
        /* @__PURE__ */ t("div", { className: s(a.bottomBorder, l) }),
        o && /* @__PURE__ */ t("div", { className: a.activeBorder })
      ]
    }
  ) : e === "step" ? /* @__PURE__ */ r(
    "div",
    {
      className: s(
        a.stepWrapper,
        o && a.active,
        n && a.completed,
        q && a.firstStep,
        N && a.lastStep
      ),
      role: "tab",
      children: [
        /* @__PURE__ */ r("div", { className: a.dotWrapper, children: [
          /* @__PURE__ */ t("div", { className: a.beforeLine }),
          /* @__PURE__ */ t("div", { className: a.dot, children: c && /* @__PURE__ */ t(g, { className: a.icon }) }),
          /* @__PURE__ */ t("div", { className: a.afterLine })
        ] }),
        i
      ]
    }
  ) : i;
}
export {
  _a as default
};
